import React from 'react';
import { Link } from 'react-router-dom';

// With BrowserRouter behind CloudFront, unknown paths are served index.html
// with a 200 so the app can boot. Without this route those paths would render
// an empty gap between the navbar and footer.
//
// The noindex tag for these URLs is applied by src/seo/DocumentMeta.js, which
// falls back to NOT_FOUND_META when no route pattern matches.
export default function NotFoundPage() {
  return (
    <main
      style={{
        maxWidth: '640px',
        margin: '0 auto',
        padding: '96px 24px 128px',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          fontSize: '0.75rem',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: '#8A94A1',
          margin: '0 0 16px',
        }}
      >
        Page not found
      </p>

      <h1
        style={{
          fontSize: 'clamp(1.75rem, 1.2rem + 2vw, 2.5rem)',
          lineHeight: 1.15,
          color: '#0D2749',
          margin: '0 0 16px',
        }}
      >
        We couldn&rsquo;t find that page
      </h1>

      <p style={{ color: '#5A6675', lineHeight: 1.65, margin: '0 0 32px' }}>
        The link may be out of date. You can browse team experiences or tell us
        what your team needs and we&rsquo;ll send back options.
      </p>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Link
          to="/browse"
          style={{
            background: '#0D2749',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '10px',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          Browse experiences
        </Link>

        <Link
          to="/personalized-ideas"
          style={{
            border: '1px solid #DCD8CE',
            color: '#0D2749',
            padding: '12px 20px',
            borderRadius: '10px',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          Get 3 ideas
        </Link>
      </div>
    </main>
  );
}
